"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateAttributesCommandReturnValuesOptionsSet = void 0;
exports.updateAttributesCommandReturnValuesOptionsSet = new Set([
    'NONE',
    'ALL_OLD',
    'UPDATED_OLD',
    'ALL_NEW',
    'UPDATED_NEW'
]);
